import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		root: {
			backgroundColor: theme.palette.primary.main,
		},
		title: {
			color: theme.palette.primary.contrastText,
			fontSize: theme.typography.h4.fontSize,
		},
		tags: {
			maxHeight: 128,
			overflowY: "auto",
		},
		dialogActions: {
			justifyContent: "flex-start",
			alignItems: "flex-start",
			padding: 15,
		},
	} satisfies Record<string, CSSObject>);